<template>
  <form v-if="orderItem" @submit.prevent="$emit('submit')">
    <div class="p-4 bg-white sticky top-0 flex justify-between border-b">
      <VSelect
        v-model="statusInput"
        :options="statusOptions"
        :reduce="(option) => option.value"
        :disabled="!canEdit || !isIdle"
        class="vue-select w-48"
      />
      <button
        type="submit"
        class="px-4 py-2 leading-5 text-sm rounded border border-transparent text-white focus:outline-none"
        :class="[
          {
            'bg-green-600': !isRejected,
            'hover:bg-green-500': !isRejected,
            'focus:border-green-700': !isRejected,
            'focus:ring ring-green-500 ring-opacity-50': !isRejected,
          },
          {
            'bg-red-600': isRejected,
            'hover:bg-red-500': isRejected,
            'focus:border-red-700': isRejected,
            'focus:ring ring-green-500 ring-opacity-50': isRejected,
          },
        ]"
      >
        <template v-if="isResolved"> Update succeed! </template>
        <template v-else-if="isRejected"> Update failed! </template>
        <template v-else> Update </template>
      </button>
    </div>
    <div class="space-y-12 p-4">
      <Attributes
        :editable="canEdit && isIdle"
        :name="orderItem.name"
        :requirements="orderItem.requirements"
        :status="orderItem.status"
        @update:name="updateName"
        @update:requirements="updateRequirements"
        @update:status="updateStatus"
      />

      <RelatedNotes
        :editable="canEdit && isIdle"
        :notes="orderItem.notes"
        @update:notes="updateNotes"
      />

      <RelatedLinks
        :editable="canEdit && isIdle"
        :links="orderItem.links"
        @updateLinks="updateLinks"
      />

      <RelatedAttachments
        v-if="orderItem.uuid"
        :production-order-item-id="orderItem.uuid"
        :editable="canEdit && isIdle"
        :attachments="orderItem.media"
        @update:attachments="updateMedia"
      />
    </div>
  </form>
</template>

<script>
import Attributes from './orderItem/Attributes.vue';
import RelatedNotes from './orderItem/RelatedNotes.vue';
import RelatedLinks from './orderItem/RelatedLinks.vue';
import RelatedAttachments from './orderItem/RelatedAttachments.vue';

const STATUS_IDLE = 'STATUS_IDLE';
const STATUS_PENDING = 'STATUS_PENDING';
const STATUS_RESOLVED = 'STATUS_RESOLVED';
const STATUS_REJECTED = 'STATUS_REJECTED';

export default {
  name: 'OrderItem',

  components: {
    Attributes,
    RelatedNotes,
    RelatedLinks,
    RelatedAttachments,
  },

  props: {
    orderItem: {
      type: Object,
      required: true,
    },
    submitStatus: {
      type: String,
      default: STATUS_IDLE,
    },
    canEdit: Boolean,
  },

  data() {
    return {
      statusOptions: [
        { value: 'draft', label: 'Draft' },
        { value: 'pending', label: 'Pending' },
        { value: 'in progress', label: 'In progress' },
        { value: 'in review', label: 'In review' },
        { value: 'completed', label: 'Completed' },
      ],
    };
  },

  computed: {
    isIdle() {
      return this.submitStatus === STATUS_IDLE;
    },
    isPending() {
      return this.submitStatus === STATUS_PENDING;
    },
    isResolved() {
      return this.submitStatus === STATUS_RESOLVED;
    },
    isRejected() {
      return this.submitStatus === STATUS_REJECTED;
    },
    statusInput: {
      get() {
        return this.orderItem.status;
      },
      set(status) {
        this.$emit('update:order-item', { ...this.orderItem, status });
      },
    },
  },

  methods: {
    updateName(name) {
      this.$emit('update:order-item', { ...this.orderItem, name });
    },
    updateRequirements(requirements) {
      this.$emit('update:order-item', { ...this.orderItem, requirements });
    },
    updateStatus(status) {
      this.$emit('update:order-item', { ...this.orderItem, status });
    },
    updateNotes(notes) {
      this.$emit('update:order-item', { ...this.orderItem, notes });
    },
    updateLinks(links) {
      this.$emit('update:order-item', { ...this.orderItem, links });
    },
    updateMedia(media) {
      this.$emit('update:order-item', { ...this.orderItem, media });
    },
  },
};
</script>
